import Avatar, { AvatarProps } from "../common/Avatar";
import React from "react";
import { store } from "@store";

export type UserAvatarProps = {
  currentUser?: boolean;
  userName?: string;
  avatarPic?: string;
} & Partial<Pick<AvatarProps, "size" | "onClick" | "style" | "className">>;

function UserAvatar({
  currentUser,
  userName = "",
  avatarPic = "",
  ...rest
}: UserAvatarProps) {
  const user = currentUser
    ? store().user.myProfile
    : { AvatarPic: avatarPic, Name: userName };

  const props = { name: user.Name, src: user.AvatarPic };

  return <Avatar {...props} {...rest} />;
}

export default UserAvatar;
